/**
 * @description: menu type
 */
export enum MenuTypeEnum {
  /**
   * 左侧菜单模式
   */
  SIDEBAR = 'sidebar',
  /**
   * 左侧菜单混合模式
   */
  MIX_SIDEBAR = 'mix-sidebar',
  /**
   * 顶部菜单混合模式
   */
  MIX = 'mix',
  /**
   * 顶部菜单模式
   */
  TOP_MENU = 'top-menu',
}

// 折叠触发器位置
export enum TriggerEnum {
  // 不显示
  NONE = 'NONE',
  // 菜单底部
  FOOTER = 'FOOTER',
  // 头部
  HEADER = 'HEADER',
}

export type Mode = 'vertical' | 'vertical-right' | 'horizontal' | 'inline';

export enum MenuModeEnum {
  /**
   * 垂直布局
   */
  VERTICAL = 'vertical',
  /**
   * 水平布局
   */
  HORIZONTAL = 'horizontal',
  /**
   * 右侧垂直布局
   */
  VERTICAL_RIGHT = 'vertical-right',
  /**
   * 内联布局
   */
  INLINE = 'inline',
}

export enum MenuSplitTyeEnum {
  NONE,
  TOP,
  LEFT,
}

export enum TopMenuAlignEnum {
  CENTER = 'center',
  START = 'start',
  END = 'end',
}

export enum MixSidebarTriggerEnum {
  HOVER = 'hover',
  CLICK = 'click',
}
